import PropTypes from 'prop-types'
import React from 'react'

import styles from './loading.module.scss'

export default function Loading({ show, variant = 'default' }) {
  if (!show) {
    return null
  }

  const containerStyles =
    variant === 'modal' ? styles.modalContainer : styles.container

  return (
    <div className={containerStyles}>
      <div className={styles.throbber}>
        <div />
        <div />
        <div />
      </div>
    </div>
  )
}

Loading.propTypes = {
  show: PropTypes.bool.isRequired,
  variant: PropTypes.oneOf(['default', 'modal']),
}
